import { Faction } from "./types";

var next_id = 0;

export class GameObj {

    public readonly id: string
    public readonly faction: Faction
    public readonly unitId: string

    private cooldownStart = 0;

    constructor(faction: Faction, type: string, id?: string) {
        this.id = id ?? ("" + next_id++);
        this.faction = faction;
        this.unitId = type;
    }

    getCooldownStart(): number {
        return this.cooldownStart;
    }

    setCooldownStart(value: number): void {
        this.cooldownStart = value;
    }

    static setIdCounter(next: number): void {
        next_id = Math.max(next_id, next);
    }

    setNotReady() {
        this.cooldownStart = Date.now() + Math.floor(Math.random() * 100);
    }

    isReady(maxCooldown: number): boolean {
        return Date.now() >= this.cooldownStart + maxCooldown;
    }

    cooldownPercentLeft(maxCooldown: number): number {
        const elapsed = Date.now() - this.cooldownStart;
        const remaining = maxCooldown - elapsed;
        return Math.max(0, Math.min(1, remaining / maxCooldown));
    }

    nudgeForAI(difficulty: number) {
        this.cooldownStart -= ([-10, -5, 0, 2, 4])[difficulty];
    }
}
